import { mutator } from 'satcheljs';
import getStore from '../store/store';
import discardInvitationOption from '../../actions/discardInvitationOption';

/**
 * Called when discard option is selected, resets the invitation options in store
 */

export default mutator(discardInvitationOption, () => {
    let optionState = getStore();
    optionState.removeOldMeetingMessages = null;
    optionState.removeForwardedMeetingNotifications = null;
});
